import React, { useState, useEffect, useRef } from 'react';
// import { useHistory, useLocation } from 'react-router-dom';
import Header from "../../../Components/Header/Header";
import Badge from 'react-bootstrap/Badge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import { faPlus, faXmark, faCircle, faPaperclip, faBolt, faEllipsis, faLink, faCircleCheck, faChevronDown, faGear } from '@fortawesome/free-solid-svg-icons';
import Export from "../../../assets/images/export.svg";
import View from "../../../assets/images/view.svg";
import Edit from "../../../assets/images/edit.png";
import Rapdf from "../../../assets/images/pdf.png";
import { Button, ProgressBar } from 'react-bootstrap';

import Cargoplane from "../../../assets/images/plane.svg";
import Cuser from "../../../assets/images/cuser.png";
import Cargotruck from "../../../assets/images/cargo-truck.png";
import { Link } from 'react-router-dom';
import ActivityComments from '../../../Components/common/ActivityComments';
import ImageUpload from '../../../Components/common/ImageUpload';
import { GETULDDETAILS, MVTHDETAILS } from '../../../Utils/conts';
import { withRFSToken } from '../../../Services/axios';
import Accordion from 'react-bootstrap/Accordion';
import LeftMenu from '../../../Components/LeftMenu/LeftMenu';
import { applyOffsetToDateTime, CallApi, jqxCookieCall } from '../../../Components/common/CommonFunctions';

const FUldDetails = ({ onBack, PDClick, AddClick }) => {
    const isMounted = useRef(false);
    const [operationDate, setOperationDate] = useState('');
    const [operationTime, setOperationTime] = useState('');
    const [sourceType, setSourceType] = useState(''); // To track which page we came from

    const [gridData, setGridData] = useState([]);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [gridSelect, setGridSelect] = useState([]);
    const gridRef = useRef(null);
    const storedData = JSON.parse(localStorage.getItem('Fdetails'));
    const id = storedData?.id;
    const F_AddULD = localStorage.getItem('F_AddULD');
    const [filterApplied, setFilterApplied] = useState(false);
    const [isLoading, setIsLoading] = useState(true);


    const loadDetails = async (uldNumber) => {
        // const storageData = localStorage.getItem('Fdetails');
        // try {
        let endpoint = '';
        let payload = {};

        if (storedData.source === 'buildup') {
            endpoint = 'uld-control/build-up-details';
            payload = { uld_id: uldNumber };
        } else if (storedData.source === 'activeTrips') {
            endpoint = 'forwarder-uld-control/receipt-details';
            payload = { receipt_id: uldNumber };
        } else if (storedData.source === 'uldStock') {
            { console.log("inside here") }
            endpoint = 'forwarder-uld-control/get-uld-details';
            payload = { uld_id: uldNumber };
        }

        // setDisLoading(true);
        CallApi({
            endPoint: endpoint,
            payload: payload,
            onSuccess: (data) => {
                const resCode = data.data.response_code;
                if (resCode === 200) {
                    const innerData = data.data.response_data;
                    setSelectedRowData(innerData);
                }
            },
            // onError: (msg) => toast.error(msg)
        });
        //     const res = await withRFSToken.post(endpoint, payload)
        //         .then(function (res) {
        //             const innerData = res.data.response_data;
        //             setSelectedRowData(innerData);
        //         });
        // } catch (error) {
        //     console.error('Error fetching data:', error);
        // }
    }

    useEffect(() => {
        if (isMounted.current) return;
        // const source = localStorage.getItem('Fdetails');
        setSourceType(storedData.source || '');
        if (storedData) {
            loadDetails(storedData.id);
        }
        setIsLoading(false);
        setGridData([]);
        isMounted.current = true;
    }, []); // Second useEffect that depends on sourceType

    // const history = useHistory();
    // const location = useLocation();

    // if (Uldid){
    //     setUldNumber(Uldid);
    //     queryParameters.delete('uld_number');
    //     history.push({
    //         pathname: location.pathname,
    //       });
    //     window.location.replace('/ULDControl/MovementHistory')
    // }
    const [uldNumber, setUldNumber] = useState();



    let checkUlds = [];
    let filterForCheck = false;
    useEffect(() => {
        if (gridRef.current) {
            // var token = "Bearer " + localStorage.ULD;
            jqxCookieCall();
            const source = {

                // url: sourceType === 'buildup'
                //     ? `${process.env.REACT_APP_RFS_URL}uld-control/sub-build-up?uld_id=${id}`
                //     : sourceType === 'activeTrips' ? `${process.env.REACT_APP_RFS_URL}uld-control/nested-trip-list?id=${id}`
                //         : `${process.env.REACT_APP_RFS_URL}uld-control/nested-trip-list?id=${id}`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                datatype: 'json',
                id: '',
                datafields: [
                    { name: 'id', type: 'string' },
                    { name: 'receipt_id', type: 'string' },
                    { name: 'receipt_number', type: 'string' },
                    { name: 'date_in', type: 'string' },
                    { name: 'date_out', type: 'string' },
                    { name: 'ulds_count', type: 'string' },
                    { name: 'receipt_pdf', type: 'string' },
                    { name: 'security_code', type: 'string' },
                    { name: 'station', type: 'string' },
                    { name: 'handler_org_name', type: 'string' }
                ],
                localdata: selectedRowData?.movementHistory
                // pagesize: 50, 
                // filter: function (allfilters) {
                //     if (allfilters.length > 0) {
                //         setFilterApplied(true);
                //         filterForCheck = true;
                //     } else {
                //         setFilterApplied(false);
                //         filterForCheck = false;
                //     }
                //     window.$(gridRef.current).jqxGrid('clearselection');
                //     window.$(gridRef.current).jqxGrid("updatebounddata", "filter");
                // },
                // beforeprocessing: function (data) {
                //     source.totalrecords = data.TotalRows;
                // },
                // sort: function (column, direction) {
                //     window.$(gridRef.current).jqxGrid("updatebounddata", "sort");
                // },
                // root: "Rows",
                // cache: false,
            };

            const dataAdapter = new window.$.jqx.dataAdapter(source);

            const columns = [
                {
                    text: 'View', width: '5%',
                    cellsrenderer: function () {
                        return '<div class="grid_actions"><img src="' + View + '" class="view_details" /></div>';
                    },
                },
                { text: 'Receipt No.', filtertype: 'input', datafield: 'receipt_number', width: '12%', cellclassname: '', },
                { text: 'Date In', filtertype: 'textbox', datafield: 'date_in', width: '10%', cellclassname: '', },
                { text: 'Date Out', filtertype: 'textbox', datafield: 'date_out', width: '10%', cellclassname: '', },
                { text: 'Ulds', filtertype: 'textbox', datafield: 'ulds_count', width: '10%', cellclassname: '', },
                {
                    text: 'Receipt', filtertype: 'textbox', datafield: 'receipt_pdf', width: '5%', cellclassname: '',
                    cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                        if (cellValue) {
                            defaultHtml = "<div style='text-align: center;line-height: 38px;'><a target='_blank' href=' " + cellValue + " '>  <img style='width: 25px;' src='" + Rapdf + "'/> </a></div>";
                        }
                        return (
                            defaultHtml
                        );
                    },
                },
                { text: 'Station', filtertype: 'textbox', datafield: 'station', width: '5%', cellclassname: '', },
                { text: 'Handler name', filtertype: 'textbox', datafield: 'handler_org_name', width: '18%', cellclassname: '', },

            ];

            // Define nested grid columns for buildup
            const nestedColumns = [
                { text: 'House Awb', datafield: 'house_awb', width: '8%' },
                { text: 'Pcs', datafield: 'pieces', width: '8%' },
                { text: 'Weight', datafield: 'weight', width: '8%' },
            ];

            // Initialize nested grid if sourceType is buildup
            const initrowdetails = (index, parentElement, gridElement, record) => {
                if (sourceType !== 'buildup') return;

                const nestedGridContainer = parentElement.children[0];
                const id = record.uid.toString();

                const nestedSource = {
                    datatype: 'json',
                    datafields: [
                        { name: 'id', type: 'string' },
                        { name: 'house_awb', type: 'string' },
                        { name: 'pieces', type: 'string' },
                        { name: 'weight', type: 'string' },
                    ],
                    url: `${process.env.REACT_APP_RFS_URL}uld-control/sub-sub-build-up?id=${record.id}`,
                    // beforeSend: function (jqXHR) {
                    //     jqXHR.setRequestHeader('Authorization', token);
                    // },
                    root: "Rows",
                    cache: false
                };

                const nestedDataAdapter = new window.$.jqx.dataAdapter(nestedSource);

                const nestedGridOptions = {
                    width: '100%',
                    pageable: false,
                    sortable: false,
                    autoheight: false,
                    height: (6 * 45),
                    selectionmode: '',
                    source: nestedDataAdapter,
                    filterable: false,
                    columns: nestedColumns,
                    rowsheight: 45,
                    showemptyrow: false
                };

                window.$(nestedGridContainer).jqxGrid(nestedGridOptions);
            };

            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: 1040,
                sortable: true,
                altrows: false,
                columnsresize: false,
                enabletooltips: false,
                editable: false,
                pageable: true,
                pageSize: 50,
                pagesizeoptions: ['50', '100', '200', '500'],
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                showstatusbar: true,
                virtualmode: true,
                rendergridrows: function (params) {
                    return params.data;
                },
                // Add nested grid support only for buildup
                rowdetails: sourceType === 'buildup',
                initrowdetails: sourceType === 'buildup' ? initrowdetails : null,
                rowdetailstemplate: sourceType === 'buildup' ? {
                    rowdetails: '<div id="nestedGrid" style="margin: 10px;"></div>',
                    rowdetailsheight: (6 * 45),
                    rowdetailshidden: true
                } : null,
                rendered: function () {
                    const rows = window.$(gridRef.current).jqxGrid('getrows');
                    (checkUlds).forEach(uldNumber => {
                        rows.forEach((element, index) => {
                            if (element.uld_number == uldNumber) {
                                window.$(gridRef.current).jqxGrid('selectrow', index);
                            }
                        });
                    });
                }
            };

            window.$(gridRef.current).jqxGrid(gridOptions);
            window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');

            window.$(gridRef.current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
            window.$(gridRef.current).on('click', `.view_details`, function (event) {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const boundIndex = window.$(gridRef.current).jqxGrid('getrowid', rowIndex);

                if (boundIndex !== undefined) {
                    const pagingInfo = window.$(gridRef.current).jqxGrid('getpaginginformation');
                    const pageIndex = pagingInfo.pagenum;
                    const pageSize = pagingInfo.pagesize;
                    const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;

                    const rowData = window.$(gridRef.current).jqxGrid('getrowdata', globalIndex);
                    // console.log('rowData', rowData);

                    if (rowData) {
                        const localData = { id: rowData.receipt_id, backId: selectedRowData?.id, source: 'activeTrips', tab: 'D' }
                        console.log('localData', localData);
                        localStorage.setItem('Fdetails', JSON.stringify(localData));
                        PDClick()
                    }
                }
            });
            window.$(gridRef.current).on('rowselect', (event) => {
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    const uldNumber = selectedRow.awb_id;
                    const selectedRowId = selectedRow.uid;
                    if (!checkUlds.includes(uldNumber)) {
                        checkUlds.push(uldNumber);
                    }
                    setGridSelect(prevGridSelect => {
                        if (!prevGridSelect.some(row => row.awb_id === uldNumber)) {
                            return [...prevGridSelect, selectedRow];
                        }
                        return prevGridSelect;
                    });
                } else {
                    if (event.args.rowindex.length > 0) {
                        const allIds = window.$(gridRef.current).jqxGrid('getrows');
                        setGridSelect(allIds);
                    } else {
                        setGridSelect([]);
                    }
                }
            });
            window.$(gridRef.current).on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row.awb_id;
                    setGridSelect(prevSelection => prevSelection.filter(row => row.awb_id !== unselectedRowId));
                    if (!checkUlds.includes(unselectedRowId)) {
                        checkUlds.push(unselectedRowId);
                    } else {
                        checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                    }
                }
            });
            window.$(gridRef.current).on('click', '.row_edit', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
            });
            window.$(gridRef.current).on('click', '.row_delete', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
            });
            window.$(gridRef.current).off('cellclick');
            window.$(gridRef.current).on('cellclick', (event) => {
                const args = event.args.row.bounddata;
                if (event.args.columnindex > 1) {
                    if (gridSelect) {
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                    }
                }
            });
        }
    }, [gridData, sourceType, selectedRowData]);




    // upload forward
    const imageUploadRef = useRef(null);
    const browseClick = () => {
        if (imageUploadRef.current) {
            imageUploadRef.current.handleBrowseFiles();
        }
    };

    const editUld = () => {
        localStorage.setItem('F_EditULD', selectedRowData.id);
        localStorage.setItem('F_AddULD', "uldstock");
        AddClick()
    }
    const statusClass = {
        'On Stock': 'fw_onstock',
        'Build Up': 'fw_progess',
        'Closed': 'fw_reserve',
        'On Trip': 'fw_planed'
    }

    return (
        <>

            {/* <div className="">
                <Header />
                <div className="schedule">
                    <LeftMenu /> */}
            <div className='main-panel'>
                {/* <Link to={storedData?.backUrl} className='stk_back'> <FontAwesomeIcon icon={faArrowLeft} /> Back</Link> */}
                <Link to='#' onClick={() => onBack(true)} className='stk_back'> <FontAwesomeIcon icon={faArrowLeft} /> Back</Link>
                <div className='maindiv'>
                    <div className='SecondDiv mt-3'>
                        {/* <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button> */}
                        <div className='girddtals_header'>
                            <h3 className='position-relative'>
                                {sourceType === 'buildup' && selectedRowData?.uld_det_id}
                                {sourceType === 'uldStock' && selectedRowData?.uld_number}
                                &nbsp;
                                <span className='position-relative'>
                                    {/* {
                                                selectedRowData?.pick_status && Array.isArray(selectedRowData?.pick_status) ?
                                                    selectedRowData?.pick_status.map((item) =>
                                                        <>
                                                            <div class={`mt-0 ${item.color_status}`} style={{ position: 'absolute', top: '1px', left: '0' }}>{item.status || ''}</div>
                                                        </>
                                                    )
                                                    : ''
                                            } */}
                                    {sourceType === 'buildup' &&
                                        <div class={`mt-0 ${selectedRowData?.buildup_status == 'Finalized' ? 'fw_complet'
                                            : selectedRowData?.buildup_status == 'In Progress' ? 'fw_progess'
                                                : ''}`} style={{ position: 'absolute', top: '1px', left: '0' }}>
                                            {selectedRowData?.buildup_status || ''}
                                        </div>
                                    }
                                    {sourceType === 'uldStock' &&
                                        <div className={`mt-0 ${statusClass[selectedRowData?.status_name]}`} style={{ position: 'absolute', top: '1px', left: '0' }}>{selectedRowData?.status_name || ''}</div>
                                    }
                                </span>
                                <Link style={{ position: 'absolute', right: '0' }} to='#' onClick={editUld}><img src={Edit} /></Link>
                            </h3>
                            <div className='d-flex actbtn'>

                                <Button variant="light" onClick={browseClick} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>
                                {/* <Dropdown>
                                    <Dropdown.Toggle variant="light" id="dropdown-basic" >
                                        <FontAwesomeIcon icon={faBolt} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item >option</Dropdown.Item>
                                        <Dropdown.Item >option</Dropdown.Item>
                                        <Dropdown.Item >option</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown> */}

                            </div>

                        </div>
                        <div className='update_info'>
                            <div className='d-flex justify-content-between align-items-center MB-2'>
                                <h4>ULD Details</h4>
                            </div>
                            <ul>
                                <li>
                                    <span>Date In :</span>
                                    {/* <span>{selectedRowData?.createdate.slice(0, 10) + ' ' + selectedRowData?.createdate.slice(11, 16)}</span> */}
                                    <span>{applyOffsetToDateTime(selectedRowData?.createdate, 'H')}</span>
                                </li>
                                <li>
                                    {/* <span>Date Out :</span>
                                    <span>{applyOffsetToDateTime(selectedRowData?.archiveDate, 'H')}</span> */}
                                    <span>Recepit No:</span>
                                    <span>{selectedRowData?.trucking_uld_receipt_info?.control_receipt_numb}</span>
                                </li>
                            </ul>
                        </div>
                        <div className='movment_history'>
                            {/* <h3>Movement History</h3> */}
                        </div>
                        {/* <div className='movment_list'>
                                    <ul>
                                       
                                    </ul>
                                </div> */}
                        <ImageUpload
                            ref={imageUploadRef}
                            attachable_type={'forwarder_uld'}
                            attachable_id={selectedRowData?.id}
                            attachments={selectedRowData?.attachments}
                            onDeleteSuccess={() => loadDetails(selectedRowData?.id)}
                        />
                        <ActivityComments
                            commentable_type={'forwarder_uld'}
                            commentable_id={selectedRowData?.id}
                            allactivities={selectedRowData?.activities}
                            onReloadDetails={() => loadDetails(selectedRowData?.id)}
                        />
                    </div>
                    <div className='trashdonload mt-3'>
                        {!isLoading && <div ref={gridRef} className='bookinggrid' ></div>}
                    </div>

                </div>

            </div>
            {/* </div>
            </div> */}
        </>
    )
}

export default FUldDetails;